import './Footer.css';

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="container site-footer__inner">
        <p>© {new Date().getFullYear()} Bloomz. All rights reserved.</p>
        <a href="https://www.bloomz.com" className="site-footer__link">
          Back to bloomz.com
        </a>
      </div>
    </footer>
  );
}
